export default class SiteSupervisorRepo {
	constructor({ supaTo, supabaseClientFactory, _ }) {
		this.supaTo = supaTo;
		this.supabase = supabaseClientFactory;
		this._ = _;
	}

	async getSiteSupervisorById(id) {
		if (!id) {
			throw new Error('id is required for get Site Supervisor by id');
		}
		const [error, data] = await this.supaTo(
			this.supabase
				.from('site_supervisor')
				.select('*')
				.match({ id }),
		);
		if (error) {
			throw error;
		} else {
			return this._.get(data, 'data[0]', null);
		}
	}

	async getSiteSupervisors() {
		const [error, data] = await this.supaTo(
			this.supabase
				.from('site_supervisor')
				.select('*'),
		);
		if (error) {
			throw error;
		} else {
			return this._.get(data, 'data', []);
		}
	}
}
